




































import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user/user.store';

import NavigationFooter from './NavigationFooter.vue';
import { INavigationItem } from '@/store/modules/navigation/navigation.items';
import { NavigationModule } from '@/store/modules/navigation/navigation.store';
import { Role } from '@/core/security/Role';

@Component({
    components: {
        NavigationFooter
    }
})
export default class SideNavigation extends Vue {
	@Prop() isLoggedIn!: boolean;

	HasPermissions(permissions: string[] | null): boolean {
	    if (!permissions || permissions.length === 0) return true;
	    return UserModule.user!.HasPermission(permissions);
	}

	HasRoles(roles: Role[] | null): boolean {
	    if (!roles || roles.length === 0) return true;
	    return UserModule.user?.HasRole(roles) ?? false;
	}

	get sideNavigationActive(): boolean {
	    return NavigationModule.showSideNavigation;
	}

	get navigationItems(): readonly INavigationItem[] {
	    return NavigationModule.navigationItems;
	}

	Toggle() {
	    const isInTabletMode = window.matchMedia('(max-width: 767px)');
	    if (isInTabletMode.matches) {
	        NavigationModule.SetSideNavigationStatus(false);
	    }
	}

	created() {
	    const isInTabletMode = window.matchMedia('(max-width: 767px)');
	    if (isInTabletMode.matches) {
	        NavigationModule.SetSideNavigationStatus(false);
	    }
	}
}
